<template>
  <div class="desktop">
    <div class="header">
      <div class="content">
        <a class="logo" href="https://jp.kkpoker.net/" target="_blank">
          <img src="/static/img/desktop/header_kk_logo.png" alt="logo"/>
        </a>
        <div class="menu">
          <a
            v-for="(menu, index) of menuList"
            :key="index"
            :href="menu.link"
            target="_blank"
          >{{ menu.label }}</a>
        </div>

        <div class="right-side">
          <a
            v-for="(menu, index) of rightMenuList"
            :key="index"
            :href="menu.link"
            target="_blank"
          >{{ menu.label }}</a>
        </div>
        <div class="mobile-header">
          <div class="download">
            <img :href="downloadLink" src="/static/img/download/download.svg"/>
            <a :href="downloadLink">ダウンロード</a>
          </div>
          <img
            src="/static/img/home/menu_01.png"
            class="menu-logo"
            @click="showPopup"
          />
        </div>
        <van-popup
          v-model="show"
          position="right"
          class="popup-slider"
        >
          <div style="float: right;">
            <img class="close_btn" @click="show=false" src="/static/img/menu/close.png" />
          </div>
          <div class="mobile-menu">
            <a
              v-for="(menu, index) of menuList"
              :key="index"
              :href="menu.link"
              target="_blank"
            >{{ menu.label }}</a>
          </div>
        </van-popup>
      </div>
    </div>
    <div class="body">
      <div class="hero-banner">
        <img class="mobile-banner" src="/static/img/pokerland/mobile_main.jpg" alt="mobile banner">
        <div class="main-block">
          <img class="pc-banner" src="/static/img/pokerland/char.png" alt="char">
          <div class="left-section">
            <img src="/static/img/pokerland/slogan.png" />
          </div>

          <div class="right-section">
            <div class="register-block settingHeight">
              <registerForm :isOlakk="true" :platform="platform"></registerForm>
            </div>
            <div class="download-block">
              <img
                class="title"
                src="/static/img/pokerland/downloadtext.png"
              />
              <div class="icon-link">
                <download-button
                  :isOlakk="true"
                  @setPlatform="platform = $event"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line-block">
        <div class="context-section">
          <img class="line-text" src="/static/img/pokerland/text_line .png" alt="text_line">
          <a class="line-btn" href="https://line.me/R/ti/p/@772vncjk" target="_blank">
            <img src="/static/img/pokerland/btn_line.png" alt="line">
          </a>
        </div>
      </div>
      <div class="ups-block" :class="isMobile ? 'mobile' : 'pc_introduction'">
        <p class="usp-title">KKPOKERでできること</p>
        <div class="swiper-container">
          <single-swiper :isPagination="isMobile" :imageList="uspImages" :swiperWidth="'100%'" :imageWidth="'100%'"
            :swiperOptions="swiperOptions" />
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="terms">
        <p class="mb-8">
          KKPoker が（ウェブサイト・タブレット・モバイル用アプリを通じて）提供する製品およびサービスを総称して、以下「サービス」とします。
        </p>
        <p class="mb-8"><span>  <a place="link" target="_blank" href="https://notice.kkpoker.net/pc/restricted_territory" style="box-shadow:0 1px;text-decoration:none;">特定の国</a>に居住または滞在している方は、サービスへのアクセスが違法になることもあります。</span>
          本規約に基づき提供されるサービスは、法律で禁止されている地域での賭け事、ゲーム、その他のサービスの利用または加入を目的とした、KKPokerによる提案、勧誘、招待を意味するものではありません。
          特に、米国に居住または滞在している方は、いずれのサービスも利用が禁止されています。
        </p>
        <p class="mb-8 d-none d-sm-flex">
          KKPoker は、Aceking IOM Limited, 49 Victoria Street, Douglas, Isle of Man, IM1 2LD が所有するブランド、および商標です。
        </p>
        <p class="mb-8 d-none d-sm-flex">
          2019 年 7 月 24 日から The Online Gambling Regulation Act （オンラインギャンブル規制法）2001年版（2019 年 7 月 24 日最終更新）に準じ、Isle of Man Gambling Supervision Commission により規制とライセンスを受けています。18 歳未満の方はアカウントの作成、ギャンブルへの参加は許可されていません。KKPokerでの入金や獲得賞金における安全は確保されており、マン島の法律が適用されます。
        </p>
      </div>
      <div class="menu-social-block">
        <div class="top-footer">
          <div class="menu-list">
            <div class="menu-item" v-for="(link, index) in footerLinks" :key="index">
              <a :href="link.href" target="_blank">
                {{ link.text }}
              </a>
            </div>
          </div>

          <div class="jump_btn mobile-show">
            <a v-for="(item, index) in jumpLinks" :key="index" target="_blank" :href="item.href">
              <img :src="item.src" :style="item.style" class="mr-2">
            </a>
          </div>

          <div class="social-list">
            <a href="https://twitter.com/KKPokerJapan" target="_blank"><img src="/static/img/pokerland/social_twitter.png" height="30px"></a>
            <a href="https://www.youtube.com/c/KKPokerJapan" target="_blank"><img src="/static/img/pokerland/social_youtube_icon.png" height="32px"></a>
            <a href="https://liff.line.me/1645278921-kWRPP32q/?accountId=035ymodw" target="_blank"><img src="/static/img/pokerland/social_line.png" height="32px"></a>
          </div>
        </div>

        <div class="right-block">
          <strong class="copyright">
            Copyright © {{  currentYear }} KKPoker. All Rights Reserved.
          </strong>
          <div class="jump_btn pc-show">
            <a v-for="(item, index) in jumpLinks" :key="index" target="_blank" :href="item.href">
              <img :src="item.src" :style="item.style" class="mr-2">
            </a>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import DownloadButton from '@/components/downloadButton.vue'
import registerForm from '@/components/registerForm.vue'
import { uploadTrack } from '@/configs/userStatsTrack'
import SingleSwiper from '@/components/SwiperComponent/SingleSwiper.vue'
import { getUspData } from '@/configs/register'
import { switchLanguage } from '@/utils/switchLang.js'
import { getGps } from '@/utils/browserCheck.js'
import { checkIpLegal } from '@/api/official'
import { setLicenseType } from '@/configs/licenseType'
import siteType from '@/configs/siteType'

export default {
  name: 'landing',
  components: {
    DownloadButton,
    registerForm,
    SingleSwiper
  },
  computed: {
    isMobile () {
      const isDesktop = window.innerWidth > 768
      return !isDesktop
    },
    swiperOptions() {
      if (this.isMobile) {
        return {
          slidesPerView: 1.26,
          spaceBetween: 0,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
            dynamicBullets: false
          }
        }
      }
      return {
        slidesPerView: 4,
        spaceBetween: 0
      }
    },
    uspImages () {
      return getUspData(this.$i18n.locale, this.globalConfig, this.isMobile)
    }
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      show: false,
      menuList: [
        { link: 'https://jp.kkpoker.net/blog/', label: 'トーナメント'},
        { link: 'https://jp.kkpoker.net/promotions/', label: 'プロモーション' },
        { link: 'https://jp.kkpoker.net/kkpros/', label: ' 著名プレイヤー' },
        { link: 'https://jp.kkpoker.net/blog/', label: 'ブログ' }
      ],
      rightMenuList: [
        { link: 'https://jp.kkpoker.net/instant-rakeback/', label: 'INSTANT RAKEBACK'},
        { link: 'https://jp.kkpoker.net/downloadpage/', label: 'ダウンロード' }
      ],
      footerLinks: [
        {
          href: 'https://jp.kkpoker.net/about',
          text: '会社概要',
        },
        {
          href: 'https://jp.kkpoker.net/PrivacyPolicy',
          text: 'プライバシーポリシー',
        },
        {
          href: 'https://jp.kkpoker.net/DepositPolicy',
          text: '入出金ポリシー',
        },
        {
          href: 'https://jp.kkpoker.net/contact',
          text: 'お問い合わせ',
        },
        {
          href: 'https://jp.kkpoker.net/TermsOfService',
          text: '利用規約',
        },
        {
          href: 'https://jp.kkpoker.net/responsible',
          text: '責任あるギャンブル',
        },
        {
          href: 'https://jp.kkpoker.net/gameIntegrity',
          text: 'ゲームインテグリティ',
        },
        {
          href: 'https://jp.kkpoker.net/legalCookiePolicy',
          text: 'Cookie に関する通知',
        },
      ],
      jumpLinks: [
        {
          href: "https://www.gov.im/categories/business-and-industries/gambling-and-e-gaming/licence-holders/",
          src: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? "/static/img/pokerland/icon/icon_06_nuts.png" : "/static/img/pokerland/icon/icon_06.png",
          style: "max-width: 40px",
        },
        {
          href: "https://access.gaminglabs.com/Certificate/Index?i=372",
          src: "/static/img/pokerland/icon/glcIocn.jpeg",
          style: "max-width: 60px",
        },
        {
          href: "https://www.gamcare.org.uk/",
          src: "/static/img/pokerland/icon/icon_08.png",
          style: "max-width: 60px",
        },
        {
          href: "https://www.begambleaware.org/",
          src: "/static/img/pokerland/icon/GambleAware.png",
        },
        {
          src: "/static/img/pokerland/icon/icon_10.png",
          style: "max-width: 30px",
        },
      ],
      downloadLink: 'https://jp.kkpoker.net/downloadpage/',
      activeNames: null,
      platform: '',
      siteType,
    }
  },
  beforeRouteEnter(to, from, next) {
    // 判斷是否為手機及獲取經緯度
    getGps().then((res) => {
      const { lat, lon } = res
      const param = lat && lon ? { type: 1 , gps_lat: lat , gps_lon: lon} : { type: 1 }
      checkIpLegal(param).then((res) => {
        setLicenseType(res)
        next()
      })
    }).finally(() => {
      next()
    })
  },
  created () {
    this.setLang()
  },
  mounted () {
  },
  methods: {
    track (deviceType) {
      const category = 'SignUp pokerland'
      this.$gtag.event('Click', {
        event_category: category,
        event_label: `Download ${deviceType}`
      })
      // upload track data to aliyun
      uploadTrack(this)
    },
    showPopup() {
      this.show = true
    },
    closePopup() {
      this.show = false
    },
    setLang () {
      const BrowLang = switchLanguage()
      this.country = this.$route.query.lang || BrowLang
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  padding: 10px 20px;
  background:#000000;

  .content {
    margin: 0 auto;
    max-width: 19rem + 4rem;
    height: 60px;
    display: flex;
    flex-direction: row;
  }

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    img {
      height: 100%;
    }
  }

  .menu,
  .right-side {
    display: flex;
    justify-content: center;
    align-items: center;

    a {
      display: block;
      color: #f2f2f2;
      text-align: center;
      padding: 10px 20px;
      text-decoration: none;
      font-size: 25px;
      text-transform: uppercase;

      &:hover {
        border-bottom: 3px solid #219655;
      }
    }
  }

  .right-side{
    margin-left: auto;
  }
  .mobile-header{
    display: none;
  }

  @media only screen and (max-width: 1040px) {
    .menu,
    .right-side {
      display: none;
    }


    .mobile-menu {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding: 20px;

      a {
        margin: 20px 0;
        display: block;
        border-left: 8px solid #219655;
        color: #f2f2f2;
        padding: 10px 20px;
        text-decoration: none;
        font-size: 25px;
        text-transform: uppercase;
      }
    }
    .mobile-header{
      margin-left: auto;
      display: flex;
      .download {
        display: flex;
      }
      a {
        display: block;
        color: #f2f2f2;
        text-align: center;
        padding: 10px 25px 10px 10px;
        text-decoration: none;
        font-size: 25px;
        text-transform: uppercase;
        &:hover {
          border-bottom: 3px solid #219655;
        }
      }
      img {
        position: relative;
        width: 30px;
      }
      .menu-logo {
        padding: 10px 30px 10px 10px;
        width: 50px;
        height: 35px;
      }
    }
    .close_btn {
      width: 25px;
      margin: 20px 20px 20px auto;
    }
    .popup-slider {
      height: 100%;
      width: 50%;
      background-color: #000000;
    }
  }
}

.body {
  display: block;
  position: relative;
  background-color: #000000;
}

.hero-banner {
  width: 100%;
  height: 80vh;
  background-image: url("/static/img/pokerland/background.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  .mobile-banner {
    display: none;
    width: 100%;
    margin-top: 50px;
  }


  @media only screen and (max-width: 768px) {
    height: auto;
    .mobile-banner {
      display: block;
    }

    .pc-banner,
    .left-section {
      display: none;
    }
  }
}
.pc-banner {
  position: absolute;
  height: 90%;
  width: auto;
  left: 10%;
  bottom: 0;
}
.main-block {
  overflow: hidden;
  margin: 0 auto;
  max-width: 19rem + 4rem;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;

  @media only screen and (max-width: 768px) {
    overflow: auto;
    height: 100vw;
  }

  .left-section {
    height: 80%;
    position: absolute;
    left: 2%;
    bottom: 5%;

    img {
      height: 85%;
    }

    @media only screen and (max-width: 768px) {
      position: relative;
    }
  }

  .right-section {
    padding: 0;
    margin-left: auto;
  }
}

.right-section {
  display: flex;
  width: fit-content;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9;
  margin-top: 7%;
  background-color: rgba(0,0,0,0.7);

  @media screen and (max-width: 768px) {
    margin: 0 auto;
    width: 100%;
  }

  * {
    box-sizing: border-box;
  }

  .register-block {
    margin: -10% 0;
    transform: scale(0.8);
    width: 850px;
    height: 780px;
    overflow: hidden;
    border: 5px solid #d2cdd1;
    background-color: #151515;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  }

  .download-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 768px) {
      display: none;
    }

    .title {
      margin: 20px 0;
      width: 700px;
    }

    .icon-link {
      white-space: nowrap;

      a {
        cursor: pointer;
      }

      img {
        margin: 10px 15px;
        width: 330px;
      }
    }
  }
}

.line-block {
  display: block;
  position: relative;
  width: 100%;
  padding: 2%;
  background-image: url("/static/img/pokerland/line_bg.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  .line-text {
    margin: 0.5rem;
    max-width: 7rem;
    width: 100%;
  }

  .line-btn {
    display: inline-blockk;
    margin: 0.5rem;
    max-width: 7rem;
    width: 100%;

    img {
      animation: glowing 1300ms infinite;
      border-radius: 18px;
      width: 100%;
    }
  }

  .context-section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    height: 100%;
    max-width: 19rem;

    @media screen and (max-width: 768px) {
      flex-direction: column;
      justify-content: center;
    }

  }
}

.ups-block {

  .usp-title {
    height: 2rem;
    line-height: 2rem;
    font-size: 40px;
    color: white;
    text-align: center;
  }

  &.pc_introduction .swiper-container {
    max-width: 19rem;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
  }

  &.mobile .swiper-container {
    width: 100%;
    background-image: url('/static/img/home/bg_2.png');
    background-position: 100% 113%;
    background-repeat: no-repeat;
    background-size: 100% auto;
  }
}

.footer {
  background-color: #000000;
  font-size: 16px;
  color: white;
  overflow: auto;

  .mb-8 {
    margin-bottom: 32px!important;
  }


  .d-none {
    display: none!important;
  }

  @media (min-width: 600px) {
    .d-sm-flex {
      display: flex!important;
    }
  }


  .terms {
    margin: 40px auto;
    padding: 0 20px;
    max-width: 19rem;

    p {
      font-size: 23px;
      line-height: 1.7;
    }

    a {
      font-size: 23px;
      color: #219655;
    }
  }

  .menu-social-block {
    margin: 40px auto;
    padding: 0 20px;
    max-width: 19rem;
  }

  .menu-list {
    display: inline-block;
    width: 70%;

    .menu-item {
      margin: 10px 0;
      display: inline-block;
      width: 33%;
    }

    @media screen and (max-width: 768px) {
      width: 100%;

      .menu-item {
        width: 100%;
      }
    }

    a {
      font-size: 20px;
      color: white;
      text-decoration: none;
    }
  }

  .social-list {
    display: inline-block;
    vertical-align: top;
    width: 30%;

    @media screen and (max-width: 768px) {
      vertical-align: middle;
      width: 100%;
    }
    a {
      margin-right: 40px;
    }
  }

  .right-block {
    margin: 40px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .copyright {
      color:rgb(140, 140, 140);
      font-size: 20px;
    }
  }


  .jump_btn {
    margin: 40px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 50%;

    &.mobile-show {
      display: none;
    }

    @media screen and (max-width: 768px) {
      &.mobile-show {
        display: flex;
        width: 100%;
      }
      &.pc-show {
        display: none;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .top-footer {
      display: flex;
      flex-direction: column-reverse;
    }
  }

}

@keyframes glowing {
  0% {
    background-color: #4ccd03;
    box-shadow: 0 0 10px #4ccd03
  }

  50% {
    background-color: #7bff49;
    box-shadow: 0 0 30px #7bff49
  }

  100% {
    background-color: #4ccd03;
    box-shadow: 0 0 10px #4ccd03
  }
}

</style>
